import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';

export default function RapiraPayoutActions({ apiUrl, payoutPk, hasDeal }) {
    const { t } = useTranslation('payouts');
    const [view, setView] = useState(null);
    const [data, setData] = useState(null);
    const [error, setError] = useState(false);
    useEffect(() => {
        if (!view) return undefined;
        const controller = new AbortController();
        setData(null);
        setError(false);
        fetch(`${apiUrl}providers/fiatpayoutrequest/${payoutPk}/rapira_${view}/`, {
            headers: { Authorization: `JWT ${localStorage.getItem('accessToken')}` },
            signal: controller.signal,
        }).then(async response => {
            if (!response.ok) throw new Error('rapira');
            const result = await response.json();
            if (!controller.signal.aborted) setData(result);
        }).catch(() => { if (!controller.signal.aborted) setError(true); });
        return () => controller.abort();
    }, [view, apiUrl, payoutPk]);
    const deals = data?.deals || (data?.deal ? [data.deal] : []);
    return <>
        <div className="payout-actions">
            <button type="button" className="payout-action-btn action-info" onClick={() => setView('history')}>{t('rapira.history')}</button>
            {hasDeal && <button type="button" className="payout-action-btn action-info" onClick={() => setView('deal')}>{t('rapira.deal')}</button>}
        </div>
        <Modal isOpen={Boolean(view)} onRequestClose={() => setView(null)} className="confirmation-modal large-modal"
            overlayClassName="confirmation-modal-overlay" contentLabel={t(view === 'history' ? 'rapira.history' : 'rapira.deal')}>
            <div className="confirmation-modal-header">
                <h2 className="confirmation-modal-title">{t(view === 'history' ? 'rapira.history' : 'rapira.deal')} {data?.payout_uid}</h2>
                <button type="button" className="confirmation-modal-close" aria-label={t('rapira.close')} onClick={() => setView(null)}>×</button>
            </div>
            <div className="confirmation-modal-content" style={{ maxHeight: '65vh', overflowY: 'auto', overflowWrap: 'anywhere' }}>
                {!data && !error && <p role="status">{t('rapira.loading')}</p>}
                {error && <p role="alert">{t('rapira.error')}</p>}
                {data && view === 'history' && <>
                    <h3>{t('rapira.log')}</h3>
                    {!data.events?.length && <p>{t('rapira.empty')}</p>}
                    {data.events?.map((event, index) => <p key={index}>{event.at} · {t(`rapira.${event.kind}`)}</p>)}
                    <h3>{t('rapira.orders')}</h3>
                </>}
                {data && !deals.length && <p>{t('rapira.empty')}</p>}
                {deals.map(deal => <div className="confirmation-modal-info-block" key={deal.order_sn}>
                    <p><strong>{deal.order_sn}</strong> · {deal.status_display}</p>
                    <p>{t('rapira.merchant')}: {deal.merchant_username || '—'}</p>
                    <p>{t('rapira.amount')}: {deal.fiat_amount_rounded} / {deal.fiat_amount} · {deal.usdt_amount} USDT</p>
                    <p>{t('rapira.rate')}: {deal.price}</p>
                    <p>{t('rapira.created')}: {deal.created_at}</p>
                    {deal.completed_at && <p>{t('rapira.completed')}: {deal.completed_at}</p>}
                    {deal.cancelled_at && <p>{t('rapira.cancelled')}: {deal.cancelled_at}</p>}
                    {deal.cancel_reason && <p>{t('rapira.reason')}: {deal.cancel_reason}</p>}
                </div>)}
                {data?.detail && <>
                    <h3>{t('rapira.details')}</h3>
                    <p>{data.detail.paymentName} · {data.detail.timeLimitMin}</p>
                    <p style={{ whiteSpace: 'pre-wrap' }}>{data.detail.sentBankDetails || data.detail.bankDetails}</p>
                    {data.detail.status && <p>{t('rapira.liveStatus')}: {data.detail.status}</p>}
                </>}
                {data?.messages && <><h3>{t('rapira.chat')}</h3>
                    {!data.messages.length && <p>{t('rapira.empty')}</p>}
                    {data.messages.map((message, index) => <div className="confirmation-modal-info-block" key={index}>
                        <small>{message.sender} · {message.time}</small>
                        <p style={{ whiteSpace: 'pre-wrap' }}>{message.text}</p>
                    </div>)}
                </>}
            </div>
            <div className="confirmation-modal-actions"><button type="button" className="confirmation-modal-button cancel" onClick={() => setView(null)}>{t('rapira.close')}</button></div>
        </Modal>
    </>;
}
